import invariant from 'invariant'
import {get} from 'lodash-es'
import accept from './accept.yml'
import allianzV1Form from './allianzV1/form.yml'
import bornNumber from './bornNumber.yml'
import csobV1Enums from './csobV1/enums.yml'
import csobV1Form from './csobV1/form.yml'
import damageClaims from './damageClaims.yml'
import enums from './enums.yml'
import form from './form.yml'
import general from './general.yml'
import generaliV1Enums from './generaliV1/enums.yml'
import generaliV1Form from './generaliV1/form.yml'
import genertelV1Enums from './genertelV1/enums.yml'
import genertelV1Form from './genertelV1/form.yml'
import insuranceCompany from './insuranceCompany.yml'
import komunalnaV1Enums from './komunalnaV1/enums.yml'
import komunalnaV1Form from './komunalnaV1/form.yml'
import kooperativaV1Enums from './kooperativaV1/enums.yml'
import kooperativaV1Form from './kooperativaV1/form.yml'
import nationalities from './nationalities.yml'
import notFound from './pages/404.yml'
import blog from './pages/blog.yml'
import contract from './pages/contract.yml'
import index from './pages/index.yml'
import insuranceCompanies from './pages/insuranceCompanies.yml'
import priceChange from './priceChange.yml'
import states from './states.yml'
import summary from './summary.yml'
import termination from './termination.yml'
import unionV2Enums from './unionV2/enums.yml'
import unionV2Form from './unionV2/form.yml'
import uniqaV1Form from './uniqaV1/form.yml'
import wustenrotV2Form from './wustenrotV2/form.yml'


export const createTemplate = (text: string, data: Record<string, string>) => {
  return text.replace(/{{([\s\S]+?)}}/g, (_match, value) => {
    return get(data, value, value)
  })
}

const translations = {
  accept,
  notFound,
  blog,
  index,
  contract,
  form,
  general,
  insuranceCompanies,
  insuranceCompany,
  summary,
  termination,
  enums,
  nationalities,
  priceChange,
  states,
  damageClaims,
  bornNumber,
  allianzV1: {
    form: allianzV1Form,
  },
  csobV1: {
    enums: csobV1Enums,
    form: csobV1Form,
  },
  generaliV1: {
    enums: generaliV1Enums,
    form: generaliV1Form,
  },
  genertelV1: {
    enums: genertelV1Enums,
    form: genertelV1Form,
  },
  komunalnaV1: {
    enums: komunalnaV1Enums,
    form: komunalnaV1Form,
  },
  kooperativaV1: {
    enums: kooperativaV1Enums,
    form: kooperativaV1Form,
  },
  unionV2: {
    enums: unionV2Enums,
    form: unionV2Form,
  },
  uniqaV1: {
    form: uniqaV1Form,
  },
  wustenrotV2: {
    form: wustenrotV2Form,
  },
}

const t = (key: string):string => {
  const translation = get(translations, key, undefined)
  if (!translation) {
    invariant(translation, `Correct translation key is required: ${key}`)
    return ''
  }
  return translation
}

export default t
